/* When the user clicks on the button,
toggle between hiding and showing the dropdown content */
function myFunction(e) {
    if (!document.getElementById(e).classList.contains("show")) {
        document.getElementById(e).classList.toggle("show");
    }
}

function filterFunction(e, i) {
    myFunction(i);
    var input, filter, ul, li, span, i;
    input = document.getElementById(e);
    filter = input.value.toUpperCase();
    div = document.getElementById(i);
    span = div.getElementsByTagName("span");
    for (i = 0; i < span.length; i++) {
        txtValue = span[i].textContent || span[i].innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            span[i].style.display = "";
        } else {
            span[i].style.display = "none";
        }
    }
    var errorSpan = $('#' + e + '-error').parent('span');
    if (!input.value.length) {
        errorSpan.show();
    }
}

function selectFunction(e, i, j) {
    var input, a;
    input = document.getElementById(i);
    a = document.getElementById(e).innerText;

    if (input && a) {
        input.value = a;
        input.setAttribute("gtm-filtervalue", document.getElementById(e).getAttribute("name"));
        document.getElementById(j).classList.toggle("show");
        var errorSpan = $('#' + i + '-error').parent('span');
        if (errorSpan.length) {
            errorSpan.hide();
        } else {
            errorSpan.show();
        }

        input.classList.remove('input-validation-error');
    }

    
}


function checkValidSearch(e, i) {
    var input, filter, ul, li, span, i;
    input = document.getElementById(e);
    filter = input.value.toUpperCase();
    div = document.getElementById(i);
    span = div.getElementsByTagName("span");
    for (i = 0; i < span.length; i++) {
        txtValue = span[i].textContent || span[i].innerText;
        if (txtValue.toUpperCase() == filter) {
            input.value = txtValue;
            break;
        } else {
            input.value = "";
        }
    }
}